
// Enum-style object for internal references
export const SegmentationMode = { 
  RECTANGLE: "rectangle",
  BRUSH: "brush",
  POINT: "point",
  FREEFORM: "freeform",
  TEXT: "text",
  BUTTON: "button", 
};

export const DEFAULT_SEGMENTATION_MODE = {
  id: 'Select',
  name: 'Select',
  description: 'Choose a segmentation mode from the list to start editing.',
  icon: 'mdi-plus',
};

// List of modes for UI rendering (buttons, tooltips, etc.)
export const SEGMENTATION_MODES = [
  {
    id: SegmentationMode.RECTANGLE,
    name: "Box Select",
    description: "Roughly draw a box around an object.",
    icon: "mdi-vector-rectangle",
  },
  {
    id: SegmentationMode.TEXT,
    name: "Texts",
    description: "Select and extract text regions from the image.",
    icon: "mdi-format-text-variant-outline",
  },
  {
    id: SegmentationMode.BUTTON,
    name: "Buttons",
    description: "Detect and extract clickable UI buttons (like 'Shop Now').",
    icon: "mdi-gesture-tap-button", 
  },
  {
    id: SegmentationMode.POINT,
    name: "Subjects",
    description: "Click an object one or more times. Shift-click to remove regions.",
    icon: "mdi-account-outline",
  },
  {
    id: SegmentationMode.BRUSH,
    name: "Brush",
    description: "Paint over areas to select or refine the region.",
    icon: "mdi-brush",
  },
  {
    id: SegmentationMode.FREEFORM,
    name: "Lasso",
    description: "Draw a freeform boundary and detect using enclosed points.",
    icon: "mdi-lasso",
  },
];

export const UnmergeMode = {
  BOX: "unmerge-box",
  BRUSH: "unmerge-brush",
};

export type UnmergeModeType = typeof UnmergeMode[keyof typeof UnmergeMode];


export const UNMERGE_MODES = [
  {
    id: UnmergeMode.BOX,
    name: "Box Select",
    description: "Draw a rectangle to unmerge parts",
    icon: "mdi-vector-rectangle",
  },
  {
    id: UnmergeMode.BRUSH,
    name: "Brush",
    description: "Brush over regions to unmerge",
    icon: "mdi-brush",
  },
];

// previewColors.ts
export const PREVIEW_TINT_COLORS = [
  "#00E5FF", // Neon Cyan – very visible on dark & light backgrounds
  "#1AFF64", // Neon Green – strong contrast, easy to differentiate
  "#FF4DFF", // Neon Pink – stands out without clashing
  "#FFD400", // Neon Yellow – bright but still readable
  "#7C4DFF", 
];

export const MIN_BRUSH_SIZE = 5;
export const MAX_BRUSH_SIZE = 100;


export const sampleLayersData = {
    "totalLayers": 8,
    "layers": [
        {
            "id": "b369d2a7-baff-4385-bf51-01d398649a98",
            "type": "image",
            "boundingBox": {
                "x": 639.7927856445312,
                "y": 91.29476928710938,
                "width": 302.290283203125,
                "height": 856.8653564453125
            },
            "style": {},
            "skipOnLoad": false,
            "imageUrl": "https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/Playground/9c4a1727-9ebc-42a1-b80e-776a277eea0f/real_person_047504b4.png",
            "name": "real person",
            "maskUrl": "https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/Stunnr-Uni/masks/b369d2a7-baff-4385-bf51-01d398649a98.png",
            "previewUrl": "https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/Stunnr-Uni/previews/b369d2a7-baff-4385-bf51-01d398649a98.png"
        },
        {
            "id": "81005ad4-ce9f-4143-b389-d19d7e7fc9ed",
            "type": "image",
            "boundingBox": {
                "x": 154.01107788085938,
                "y": 90.21463012695312,
                "width": 297.869873046875,
                "height": 865.515380859375
            },
            "style": {},
            "skipOnLoad": false,
            "imageUrl": "https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/Playground/bf8e375c-b21c-493a-bd23-071b74da9073/real_person_14c8247b.png",
            "name": "real person",
            "maskUrl": "https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/Stunnr-Uni/masks/81005ad4-ce9f-4143-b389-d19d7e7fc9ed.png",
            "previewUrl": "https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/Stunnr-Uni/previews/81005ad4-ce9f-4143-b389-d19d7e7fc9ed.png"
        },
        {
            "id": "038deb4a-38a4-42bd-955f-5855e1b886a1",
            "type": "image",
            "boundingBox": {
                "x": 318.2200012207031,
                "y": 87.4552001953125,
                "width": 423.7233581542969,
                "height": 894.5933837890625
            },
            "style": {},
            "skipOnLoad": false,
            "imageUrl": "https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/Playground/4f399692-e0f0-45f9-bb41-701438b4bf2e/real_person_f88a0cc1.png",
            "name": "real person",
            "maskUrl": "https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/Stunnr-Uni/masks/038deb4a-38a4-42bd-955f-5855e1b886a1.png",
            "previewUrl": "https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/Stunnr-Uni/previews/038deb4a-38a4-42bd-955f-5855e1b886a1.png"
        },
        {
            "id": "5c22a3e5-2b15-46a6-b607-756833974e88",
            "type": "image",
            "boundingBox": {
                "x": 34.142547607421875,
                "y": 36.64692687988281,
                "width": 169.01870727539062,
                "height": 113.11837768554688
            },
            "style": {},
            "skipOnLoad": false,
            "imageUrl": "https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/Playground/cc7883f0-d779-4064-9955-6ce41be20c25/brand_logo_a551ae54.png",
            "name": "brand logo",
            "maskUrl": "https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/Stunnr-Uni/masks/5c22a3e5-2b15-46a6-b607-756833974e88.png",
            "previewUrl": "https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/Stunnr-Uni/previews/5c22a3e5-2b15-46a6-b607-756833974e88.png"
        },
        {
            "id": "0e4afb9b-9ccb-4017-8789-20b22f0efb29",
            "text": "TANISHQ",
            "type": "text",
            "textType": "product",
            "style": {
                "fontFamily": "Cinzel",
                "fontSize": 44.0,
                "fontWeight": "bold",
                "textAlignment": "left",
                "color": "#bc2d2d",
                "textLines": 1
            },
            "boundingBox": {
                "x": 36.0,
                "y": 83.0,
                "width": 171.0,
                "height": 66.0
            },
            "maskUrl": "https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/Stunnr-Uni/text_masks/0e4afb9b-9ccb-4017-8789-20b22f0efb29.png",
            "skipOnLoad": false
        },
        {
            "id": "72a1d4ad-4b10-4345-bf73-6d73763dcd24",
            "text": "FESTIVE\nRADIANCE",
            "type": "text",
            "textType": "headline",
            "style": {
                "fontFamily": "Playfair Display",
                "fontSize": 53.0,
                "fontWeight": "bold",
                "textAlignment": "left",
                "color": "#f7df97",
                "textLines": 2
            },
            "boundingBox": {
                "x": 38.0,
                "y": 500.0,
                "width": 315.0,
                "height": 108.0
            },
            "maskUrl": "https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/Stunnr-Uni/text_masks/72a1d4ad-4b10-4345-bf73-6d73763dcd24.png",
            "skipOnLoad": false
        },
        {
            "id": "ee4f055d-6d2f-4818-9d57-a454175fda9c",
            "text": "Embrace the Glow",
            "type": "text",
            "textType": "subheadline",
            "style": {
                "fontFamily": "Lora",
                "fontSize": 28.0,
                "fontWeight": "normal",
                "textAlignment": "left",
                "color": "#ececec",
                "textLines": 1
            },
            "boundingBox": {
                "x": 42.0,
                "y": 604.0,
                "width": 238.0,
                "height": 32.0
            },
            "maskUrl": "https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/Stunnr-Uni/text_masks/ee4f055d-6d2f-4818-9d57-a454175fda9c.png",
            "skipOnLoad": false
        },
        {
            "id": "09972ff0-d452-4432-9b14-7608cfe63eff",
            "type": "image",
            "boundingBox": {
                "x": 756.0,
                "y": 856.0,
                "width": 241.0,
                "height": 123.0
            },
            "style": {},
            "skipOnLoad": false,
            "imageUrl": "https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/Playground/dbf0b3a9-dc22-4e54-8870-eb662d933b4e/manual_0_7497d64e.png",
            "name": "manual_0",
            "maskUrl": "https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/Stunnr-Uni/masks/09972ff0-d452-4432-9b14-7608cfe63eff.png",
            "previewUrl": "https://s3.amazonaws.com/deltax.testing/BPs/17419/Stunnr-AI/Stunnr-Uni/previews/09972ff0-d452-4432-9b14-7608cfe63eff.png"
        }
    ]
}




